import { ROIHypotheses } from '../../shared/types';

export interface ScenarioResult {
  leads_necessarios_payback: number;
  vendas_necessarias_payback: number;
  receita_adicional_estimada: number;
  lucro_adicional_estimado: number;
  roi_estimado_pct: number;
  custo_estimado_por_lead: number;
  custo_estimado_por_aquisicao: number;
}

export interface ROICalculationResult {
  custo_total_investimento: number;
  conservador: ScenarioResult;
  esperado: ScenarioResult;
  otimista: ScenarioResult;
  disclaimer: string;
}

export function calculateROI(
  hypotheses: ROIHypotheses,
  custo_servicos_mes: number
): ROICalculationResult {
  const investimento_total = (hypotheses.investimento_midia_mes || 0) + custo_servicos_mes;
  const ticket = hypotheses.ticket_medio || 100;
  const margem_pct = (hypotheses.margem_estimada_pct || 30) / 100;
  const conversao_base = (hypotheses.taxa_conversao_pct || 5) / 100;

  // Calculo de vendas necessarias para cobrir o investimento (Payback)
  const lucro_por_venda = ticket * margem_pct;
  const vendas_payback = lucro_por_venda > 0 ? Math.ceil(investimento_total / lucro_por_venda) : 0;
  const leads_payback = conversao_base > 0 ? Math.ceil(vendas_payback / conversao_base) : 0;

  const buildScenario = (multiplicadorLeads: number, multiplicadorConversao: number): ScenarioResult => {
    const leadsNovos = Math.round((hypotheses.leads_atuais_mes || 10) * multiplicadorLeads);
    const taxaConversaoEfetiva = conversao_base * multiplicadorConversao;
    const vendasNovas = Math.round(leadsNovos * taxaConversaoEfetiva);
    
    const receitaAdicional = vendasNovas * ticket;
    const lucroAdicional = receitaAdicional * margem_pct;
    const roiPct = investimento_total > 0 
      ? Math.round(((lucroAdicional - investimento_total) / investimento_total) * 100)
      : 0;

    const cpl = leadsNovos > 0 ? Number((investimento_total / leadsNovos).toFixed(2)) : 0;
    const cac = vendasNovas > 0 ? Number((investimento_total / vendasNovas).toFixed(2)) : 0;

    return {
      leads_necessarios_payback: leads_payback,
      vendas_necessarias_payback: vendas_payback,
      receita_adicional_estimada: receitaAdicional,
      lucro_adicional_estimado: lucroAdicional,
      roi_estimado_pct: roiPct,
      custo_estimado_por_lead: cpl,
      custo_estimado_por_aquisicao: cac,
    };
  };

  return {
    custo_total_investimento: investimento_total,
    conservador: buildScenario(1.2, 0.9), // +20% leads, 90% conversão base
    esperado: buildScenario(1.6, 1.1),    // +60% leads, 110% conversão base
    otimista: buildScenario(2.2, 1.3),    // +120% leads, 130% conversão base
    disclaimer: 'Estimativa baseada nos dados e hipóteses informados. Resultados reais podem variar de acordo com o mercado e execução.',
  };
}
